import styled from "styled-components"
import {Col, Row} from "react-bootstrap"

import Button from "@irati/ui/src/Button"
import {greys, perkbox} from "@irati/ui/src/global/colors"

export const CancelButton = styled(Button)`
  margin-right: ${({theme}) => theme.spacing.one};
`

export const StyledSelecter = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: ${({theme}) => `${theme.spacing.four} 0px ${theme.spacing.one}`};
`

interface SelectItemProps {
  selected: boolean
}

export const StyledSelectItem = styled.div<SelectItemProps>`
  border-color: ${(props) => (props.selected ? perkbox.blue : greys.light)};
  border-radius: 3px;
  border-width: 1px;
  border-style: solid;
  box-shadow: ${(props) => (props.selected ? `0px 0px 11px ${greys.light}` : "")};
  cursor: pointer;
  margin-bottom: ${({theme}) => theme.spacing.one};
  padding: 15px;
  text-align: center;
  width: 160px;

  -webkit-transition: box-shadow 200ms ease-out, border 200ms ease-out;
  -moz-transition: box-shadow 200ms ease-out, border 200ms ease-out;
  -o-transition: box-shadow 200ms ease-out, border 200ms ease-out;
  transition: box-shadow 200ms ease-out, border 200ms ease-out;
`

export const StyledRow = styled(Row)`
  display: flex;
  flex-direction: column;
  height: 50px;
  justify-content: center;
  padding: 0 5px;
`

export const StyledVerticalDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

interface SelectColProps {
  height: number
}

export const StyledCol = styled(Col)<SelectColProps>`
  background: ${greys.lightest};
  border-radius: 3px;
  border: 1px solid ${greys.mediumDark};
  height: ${(props) => props.height}px;
  margin: ${({theme}) => `0 2px ${theme.spacing.one} 2px`};
`
